angular.
module("dx.webapp.api").
factory("dxApiV1ClientVersions", function apiV1ClientVersionsService(
	$http,

	DxClientVersion
) {
	"use strict";

	var path = "/api/v1/clientversions";

	function get() {
		function onResolve(response) {
			for (var i = 0; i < response.data.length; i++) {
				response.data[i] = new DxClientVersion(response.data[i]);
			}

			return response;
		}

		return $http.get(path).then(onResolve);
	}

	function post(version, platform, buildKey, architecture) {
		var clientVersion = new DxClientVersion({
			versionNumber: version,
			platform: platform,
			buildKey: buildKey,
			arch: architecture,
		});

		return $http.post(path, clientVersion);
	}

	function put(clientVersionData) {
		var clientVersion = new DxClientVersion(clientVersionData);
		return $http.put(path + "/" + clientVersion.id, clientVersion);
	}

	function del(id) {
		return $http.delete(path + "/" + id);
	}

	return {
		get: get,
		post: post,
		put: put,
		delete: del,
	};
});
